import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IUserFields {
		id?: any;
		displayName?: any;
		selected?: any;
		defaultOrganisationId?: any;
		userName?: any;
		email?: any;
		emailConfirmed?: any;
		accessFailedCount?: any;
		concurrencyStamp?: any;
		lockoutEnabled?: any;
		lockoutEnd?: any;
		normalizedEmail?: any;
		normalizedUserName?: any;
		passwordHash?: any;
		phoneNumber?: any;
		phoneNumberConfirmed?: any;
		securityStamp?: any;
		twoFactorEnabled?: any;
		isSuperAdmin?: any;
		changedBy?: any;
		datestamp?: any;
		status?: any;
		passwordExpiryEnabled?: any;
		passwordExpiryDatestamp?: any;
		typeId?: any;
		firstname?: any;
		lastname?: any;
		dob?: any;
		sisproPrefix?: any;
		password?: any;
  confirmPassword?: any;
  signatureFileCabinetId?: any;
}

export class UserFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public displayName: IEntityModelField = { name: "displayName", displayName: "User", fieldType: FieldType.String, readOnly: true };
	public selected: IEntityModelField = { name: "selected", displayName: "Selected", fieldType: FieldType.Byte };
	public defaultOrganisationId: IEntityModelField = { name: "defaultOrganisationId", displayName: "Default Organisation Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public userName: IEntityModelField = { name: "userName", displayName: "User Name", fieldType: FieldType.String, pattern: "NameGeneric" };
	public email: IEntityModelField = { name: "email", displayName: "Email", fieldType: FieldType.String, pattern: "NameGeneric" };
	public emailConfirmed: IEntityModelField = { name: "emailConfirmed", displayName: "Email Confirmed", fieldType: FieldType.Byte, pattern: "NameGeneric", required: true };
	public accessFailedCount: IEntityModelField = { name: "accessFailedCount", displayName: "Access Failed Count", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public concurrencyStamp: IEntityModelField = { name: "concurrencyStamp", displayName: "Concurrency Stamp", fieldType: FieldType.String, pattern: "NameGeneric" };
	public lockoutEnabled: IEntityModelField = { name: "lockoutEnabled", displayName: "Lockout Enabled", fieldType: FieldType.Byte, pattern: "NameGeneric", required: true };
	public lockoutEnd: IEntityModelField = { name: "lockoutEnd", displayName: "Lockout End", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public normalizedEmail: IEntityModelField = { name: "normalizedEmail", displayName: "Normalized Email", fieldType: FieldType.String, pattern: "NameGeneric" };
	public normalizedUserName: IEntityModelField = { name: "normalizedUserName", displayName: "Normalized User Name", fieldType: FieldType.String, pattern: "NameGeneric" };
	public passwordHash: IEntityModelField = { name: "passwordHash", displayName: "Password Hash", fieldType: FieldType.String, pattern: "NameGeneric" };
	public phoneNumber: IEntityModelField = { name: "phoneNumber", displayName: "Phone Number", fieldType: FieldType.String, pattern: "NameGeneric" };
	public phoneNumberConfirmed: IEntityModelField = { name: "phoneNumberConfirmed", displayName: "Phone Number Confirmed", fieldType: FieldType.Byte, pattern: "NameGeneric", required: true };
	public securityStamp: IEntityModelField = { name: "securityStamp", displayName: "Security Stamp", fieldType: FieldType.String, pattern: "NameGeneric" };
	public twoFactorEnabled: IEntityModelField = { name: "twoFactorEnabled", displayName: "Two Factor Enabled", fieldType: FieldType.Byte, pattern: "NameGeneric", required: true };
	public isSuperAdmin: IEntityModelField = { name: "isSuperAdmin", displayName: "Is Super Admin", fieldType: FieldType.Byte, pattern: "NameGeneric", required: true };
	public changedBy: IEntityModelField = { name: "changedBy", displayName: "Changed By", fieldType: FieldType.String, pattern: "NameGeneric" };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public passwordExpiryEnabled: IEntityModelField = { name: "passwordExpiryEnabled", displayName: "Password Expiry Enabled", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public passwordExpiryDatestamp: IEntityModelField = { name: "passwordExpiryDatestamp", displayName: "Password Expiry Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public typeId: IEntityModelField = { name: "typeId", displayName: "Type Id", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public firstname: IEntityModelField = { name: "firstname", displayName: "Firstname", fieldType: FieldType.String, pattern: "NameGeneric" };
	public lastname: IEntityModelField = { name: "lastname", displayName: "Lastname", fieldType: FieldType.String, pattern: "NameGeneric" };
	public dob: IEntityModelField = { name: "dob", displayName: "DOb", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public sisproPrefix: IEntityModelField = { name: "sisproPrefix", displayName: "Sispro Prefix", fieldType: FieldType.String, pattern: "NameGeneric" };
	public password: IEntityModelField = { name: "password", displayName: "Password", fieldType: FieldType.String };
  public confirmPassword: IEntityModelField = { name: "confirmPassword", displayName: "Confirm Password", fieldType: FieldType.String };
  public signatureFileCabinetId: IEntityModelField = { name: "signatureFileCabinetId", displayName: "Signature", fieldType: FieldType.String };
  
	constructor() {
		super();
		this.push(this.id);
		this.push(this.displayName);
		this.push(this.selected);
		this.push(this.defaultOrganisationId);
		this.push(this.userName);
		this.push(this.email);
		this.push(this.emailConfirmed);
		this.push(this.accessFailedCount);
		this.push(this.concurrencyStamp);
		this.push(this.lockoutEnabled);
		this.push(this.lockoutEnd);
		this.push(this.normalizedEmail);
		this.push(this.normalizedUserName);
		this.push(this.passwordHash);
		this.push(this.phoneNumber);
		this.push(this.phoneNumberConfirmed);
		this.push(this.securityStamp);
		this.push(this.twoFactorEnabled);
		this.push(this.isSuperAdmin);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
		this.push(this.passwordExpiryEnabled);
		this.push(this.passwordExpiryDatestamp);
		this.push(this.typeId);
		this.push(this.firstname);
		this.push(this.lastname);
		this.push(this.dob);
		this.push(this.sisproPrefix);
		this.push(this.password);
      this.push(this.confirmPassword);
      this.push(this.signatureFileCabinetId);
	}
}

export class UserDTO implements IEntityModel {
	protected userName: string = "UserModel";
	protected userKeyField: string = "id";
	protected userDisplayName: string = "User|Users";
	protected userFields = new UserFields();
	public get name(): string { return this.userName };
	public get keyField(): string { return this.userKeyField };
	public get displayName(): string { return this.userDisplayName };
	public get fields(): UserFields { return this.userFields };

	constructor() {};
}
